import { h } from 'preact';
import { memo, useContext, useMemo } from 'preact/compat';
import { AccessibilityFeaturesContext } from '../use-accessibility-fetures';

interface FeatureStepsProps {
  featureName: string;
}

const INACTIVE = 0;
const TOGGLE_ONLY = 2;

const FeatureStepsComponent = ({ featureName }: FeatureStepsProps) => {
  const { allyFeaturesState } = useContext(AccessibilityFeaturesContext);

  const { actionState, actionStatesMeta, disabledSteps } = allyFeaturesState[featureName];

  const actionStepsCount = useMemo(() => {
    const totalSteps = Object.keys(actionStatesMeta).length;
    const disabledStepsCount = disabledSteps?.length || 0;

    return totalSteps - disabledStepsCount;
  }, [actionStatesMeta, disabledSteps, actionState]);

  const shouldShowSteps = actionState !== INACTIVE && actionStepsCount > TOGGLE_ONLY;

  const stepsClassName = `uwaw-features__item__steps ${shouldShowSteps ? 'uwaw-features__item__steps_visible' : ''}`;

  return (
    <span className={stepsClassName}>
      {Array.from({ length: actionStepsCount - 1 }, (_, index) => (
        <span
          key={index}
          className={`uwaw-features__step ${index + 1 <= actionState ? 'uwaw-features__step_active' : ''}`}
        >
          <span className="uwaw-features__step__i" />
        </span>
      ))}
    </span>
  );
};

export const FeatureSteps = memo(FeatureStepsComponent);
